/** Sales process strengths. Keyed by slug; index is radar/table column order. */
export const order = ["preparingTheGround", "identifyingOpportunities", "contactingPotentialCustomers", "establishingRelationships", "preparingASolution", "makingTheDeal", "deliveringToPromise", "ensureCustomerSatisfaction"];

const dictionary = {
  "en": {
    "preparingTheGround": {
      "id": "preparingTheGround",
      "index": 0,
      "title": "Preparing the ground",
      "summary": "Understands the product/service portfolio; identifies trends and market; defines and monitors objectives.",
      "high": [
        "Interested in products, trends and how the market develops, identifying (new) opportunities",
        "A greater ability to recognize the big picture and the commercial opportunities and trends associated with it",
        "Drive to move things forward with energy and a fast pace"
      ],
      "low": [
        "Significant commercial trends and opportunities are recognized too late, leaving not enough time to prepare or seize them",
        "The organization can not produce new solutions / concept to market"
      ]
    },
    "identifyingOpportunities": {
      "id": "identifyingOpportunities",
      "index": 1,
      "title": "Identifying oppertunities",
      "summary": "Identifies potential customer groups; collects data on prospects; plans the suitable approach.",
      "high": [
        "A greater ability to recognize potential clients who they can win and how to approach them",
        "Systematic in their approach, competitive and wanting to challenge themselves professionally"
      ],
      "low": [
        "The team focuses their efforts too much on clients with whom they don’t have a competitive advantage / edge or a way to distinguish themselves from the rest of the market",
        "The organization lacks the ability to recognize new clients"
      ]
    },
    "contactingPotentialCustomers": {
      "id": "contactingPotentialCustomers",
      "index": 2,
      "title": "Contacting potential customers",
      "summary": "Generates leads, calls / contacts customers; writes convincing emails and messages; establish appointments.",
      "high": [
        "Confident and social professional in sales, who fills their calendar with an energetic and conscientious approach to their work.",
        "Able to generate leads for the sales team through a variety of channels based on their strengths (face-to-face, phone or digital avenues).",
        "The best lead generators are commonly motivated by a strong passion for the product/service that they are advocating for, in a respectful manner for all."
      ],
      "low": [
        "Client and lead meetings with interested parties  fail to be manifested in sufficient numbers.",
        "The organization and it’s message may not gain enough attention in the market its operating in."
      ]
    },
    "establishingRelationships": {
      "id": "establishingRelationships",
      "index": 3,
      "title": "Establishing relationships",
      "summary": "Builds rapport in meetings; aims to understand customer needs; leaves a positive impression.",
      "high": [
        "Makes a fantastic first impression and builds rapport",
        "A natural networker and great at understanding different types of behaviour for its intended purposes",
        "Usually focus on other people and their team in which they appreciate a fair and fun environment"
      ],
      "low": [
        "A network of new useful contacts is not actively developed and remains under-utilized",
        "The customer relationship doesn’t get past a transactional phase, meaning there is minimal amounts of rapport which makes bringing up challenges, problems and goals difficult"
      ]
    },
    "preparingASolution": {
      "id": "preparingASolution",
      "index": 4,
      "title": "Preparing a solution",
      "summary": "Identifies suitable products / services / solution to customer needs and problems; builds a proposal; ensures availability of resources.",
      "high": [
        "Great at recognizing and solving even the complex challenges faced by the client",
        "Tend to be open to experience new things and have posses a vivid imagination",
        "Skilled at crafting a tailored solution solution for the client or the concept",
        "Having enough resources and cooperation is valued"
      ],
      "low": [
        "Solutions offered are not appropriate for the client and don’t distinguish themselves positively in the market",
        "The quality of the solutions is lacking or doesn’t take into consideration the long-term effects"
      ]
    },
    "makingTheDeal": {
      "id": "makingTheDeal",
      "index": 5,
      "title": "Making the deal",
      "summary": "Makes presentations; discuss options; promotes plans and ideas, negotiates successfully to reach agreements.",
      "high": [
        "Good at getting the deal",
        "Confident, competitive and result orientated",
        "A natural at giving presentations and discussing different options",
        "Financial incentive and opportunities to take ownership and have an impact are common motivators"
      ],
      "low": [
        "Clients are not convinced of the suggested arrangements, making it harder to close the deal",
        "The negotiated agreement has some involved parties getting “the short end of the stick” in the long-term"
      ]
    },
    "deliveringToPromise": {
      "id": "deliveringToPromise",
      "index": 6,
      "title": "Delivering to promise",
      "summary": "Prepares the delivery; informs and involves others; monitors delivery to reach goals and expectations.",
      "high": [
        "Ensures that the client receives the product/service according to what has been agreed and promised",
        "Like to use their energy to prepare, ship, follow and deliver the product/service while keeping the client and the team informed",
        "Feedback from a positively received delivery and clear responsibilities and structures motivates these individuals"
      ],
      "low": [
        "Promises to customer aren’t kept",
        "Schedules, budgets and logistics encounter frequent problems"
      ]
    },
    "ensureCustomerSatisfaction": {
      "id": "ensureCustomerSatisfaction",
      "index": 7,
      "title": "Ensure customer satisfaction",
      "summary": "Keeps in touch with clients; monitors satisfaction; helps to solve potential problems.",
      "high": [
        "Social team players who are very considerate of others",
        "Enjoying working with existing customers, ensuring that their needs are met and are satisfied. Not afraid to jump in and customers and clients to fix potential issues and challenges",
        "A positive and open work environment is usually an important value and motivator to these individuals"
      ],
      "low": [
        "There is a lot of churn with clients and customers. Even good and highly profitable clients are lost more easily than they should be",
        "Not being aware of clients’ needs and current situation"
      ]
    }
  },
  "de": {
    "preparingTheGround": {
      "id": "preparingTheGround",
      "index": 0,
      "title": "Den Boden bereiten",
      "summary": "Versteht das Produkt- und Leistungsportfolio; erkennt Trends und den Markt; definiert Ziele und steuert sie.",
      "high": [
        "Interessiert sich für Produkte, Trends und die Marktentwicklung und erkennt (neue) Chancen",
        "Größere Fähigkeit, das Gesamtbild sowie die damit verbundenen geschäftlichen Chancen und Trends zu erkennen",
        "Antrieb, Dinge mit Energie und hohem Tempo voranzubringen"
      ],
      "low": [
        "Wesentliche Markttrends und Geschäftschancen werden zu spät erkannt, sodass zu wenig Zeit bleibt, sich vorzubereiten oder sie zu nutzen",
        "Die Organisation kann keine neuen Lösungen oder Konzepte auf den Markt bringen"
      ]
    },
    "identifyingOpportunities": {
      "id": "identifyingOpportunities",
      "index": 1,
      "title": "Chancen identifizieren",
      "summary": "Identifiziert potenzielle Kundengruppen; erhebt Daten zu Interessenten; plant den geeigneten Ansatz.",
      "high": [
        "Größere Fähigkeit zu erkennen, welche potenziellen Kundinnen und Kunden gewonnen werden können und wie sie anzusprechen sind",
        "Systematisch im Vorgehen, wettbewerbsorientiert und bereit, sich beruflich herauszufordern"
      ],
      "low": [
        "Das Team konzentriert seine Anstrengungen zu stark auf Kundinnen und Kunden, bei denen kein Wettbewerbsvorteil oder keine Differenzierung vom restlichen Markt besteht",
        "Der Organisation fehlt die Fähigkeit, neue Kundinnen und Kunden zu erkennen"
      ]
    },
    "contactingPotentialCustomers": {
      "id": "contactingPotentialCustomers",
      "index": 2,
      "title": "Potenzielle Kunden ansprechen",
      "summary": "Generiert Leads, ruft Kundinnen und Kunden an bzw. nimmt Kontakt auf; schreibt überzeugende E-Mails und Nachrichten; vereinbart Termine.",
      "high": [
        "Selbstsichere, sozial kompetente Vertriebsprofis, die ihren Kalender mit energetischem und gewissenhaftem Arbeitseinsatz füllen.",
        "Können über verschiedene Kanäle Leads für das Vertriebsteam generieren – je nach Stärke persönlich, telefonisch oder digital.",
        "Die besten Lead-Generatoren treibt in der Regel eine starke Leidenschaft für das beworbene Produkt bzw. die Leistung an, und das in einem respektvollen Umgang mit allen."
      ],
      "low": [
        "Kunden- und Lead-Gespräche mit Interessierten kommen nicht in ausreichender Zahl zustande.",
        "Die Organisation und ihre Botschaft gewinnen im bearbeiteten Markt möglicherweise zu wenig Aufmerksamkeit."
      ]
    },
    "establishingRelationships": {
      "id": "establishingRelationships",
      "index": 3,
      "title": "Beziehungen aufbauen",
      "summary": "Baut in Gesprächen Rapport auf; zielt darauf, Kundenbedürfnisse zu verstehen; hinterlässt einen positiven Eindruck.",
      "high": [
        "Hinterlässt einen überzeugenden ersten Eindruck und baut Rapport auf",
        "Netzwerkt natürlich und versteht unterschiedliche Verhaltensweisen im Hinblick auf den jeweiligen Zweck",
        "Richtet den Fokus in der Regel auf andere Menschen und das Team und schätzt ein faires, angenehmes Umfeld"
      ],
      "low": [
        "Ein Netzwerk neuer nützlicher Kontakte wird nicht aktiv aufgebaut und bleibt ungenutzt",
        "Die Kundenbeziehung kommt über eine transaktionale Phase nicht hinaus; der Rapport bleibt gering, sodass Herausforderungen, Probleme und Ziele schwer anzusprechen sind"
      ]
    },
    "preparingASolution": {
      "id": "preparingASolution",
      "index": 4,
      "title": "Eine Lösung vorbereiten",
      "summary": "Identifiziert passende Produkte, Leistungen oder Lösungen für Kundenbedürfnisse und -probleme; erstellt ein Angebot; stellt die Verfügbarkeit von Ressourcen sicher.",
      "high": [
        "Erkennt und löst auch komplexe Herausforderungen der Kundenseite überzeugend",
        "Sind offen für neue Erfahrungen und verfügen über eine lebhafte Vorstellungskraft",
        "Können eine maßgeschneiderte Lösung für die Kundenseite oder das Konzept entwickeln",
        "Ausreichende Ressourcen und Zusammenarbeit werden wertgeschätzt"
      ],
      "low": [
        "Die angebotenen Lösungen passen nicht zur Kundenseite und heben sich am Markt nicht positiv ab",
        "Die Qualität der Lösungen ist unzureichend oder berücksichtigt die langfristigen Auswirkungen nicht"
      ]
    },
    "makingTheDeal": {
      "id": "makingTheDeal",
      "index": 5,
      "title": "Den Abschluss erzielen",
      "summary": "Hält Präsentationen; diskutiert Optionen; wirbt für Pläne und Ideen; verhandelt erfolgreich bis zur Einigung.",
      "high": [
        "Gut darin, den Abschluss zu erzielen",
        "Selbstsicher, wettbewerbsorientiert und ergebnisorientiert",
        "Natürlich in Präsentationen und in der Diskussion unterschiedlicher Optionen",
        "Finanzielle Anreize sowie die Möglichkeit, Verantwortung zu übernehmen und Wirkung zu erzielen, sind häufige Motivatoren"
      ],
      "low": [
        "Kundinnen und Kunden sind von den vorgeschlagenen Vereinbarungen nicht überzeugt, sodass der Abschluss schwerer fällt",
        "Die ausgehandelte Vereinbarung benachteiligt einzelne Beteiligte auf lange Sicht"
      ]
    },
    "deliveringToPromise": {
      "id": "deliveringToPromise",
      "index": 6,
      "title": "Versprechen einlösen",
      "summary": "Bereitet die Lieferung vor; informiert und bezieht andere ein; steuert die Lieferung, um Ziele und Erwartungen zu erreichen.",
      "high": [
        "Stellt sicher, dass die Kundenseite Produkt bzw. Leistung so erhält, wie vereinbart und zugesagt",
        "Setzen ihre Energie gern dafür ein, Produkt bzw. Leistung vorzubereiten, auszuliefern, nachzuverfolgen und zu übergeben – und halten Kundenseite und Team dabei auf dem Laufenden",
        "Feedback zu einer positiv aufgenommenen Lieferung sowie klare Verantwortlichkeiten und Strukturen motivieren diese Personen"
      ],
      "low": [
        "Zusagen gegenüber Kundinnen und Kunden werden nicht eingehalten",
        "Termine, Budgets und Logistik geraten häufig ins Stocken"
      ]
    },
    "ensureCustomerSatisfaction": {
      "id": "ensureCustomerSatisfaction",
      "index": 7,
      "title": "Kundenzufriedenheit sicherstellen",
      "summary": "Hält Kontakt zu Kundinnen und Kunden; beobachtet die Zufriedenheit; hilft, mögliche Probleme zu lösen.",
      "high": [
        "Soziale Teamplayer, die sehr rücksichtsvoll gegenüber anderen sind",
        "Arbeiten gern mit bestehenden Kundinnen und Kunden, stellen sicher, dass Bedürfnisse erfüllt und Zufriedenheit erreicht wird. Scheuen sich nicht, einzuspringen und potenzielle Probleme und Herausforderungen zu lösen",
        "Ein positives, offenes Arbeitsumfeld ist für diese Personen in der Regel ein wichtiger Wert und Motivator"
      ],
      "low": [
        "Es gibt hohe Abwanderung bei Kundinnen und Kunden. Selbst gute und sehr profitable Beziehungen gehen leichter verloren, als es sein müsste",
        "Bedürfnisse und aktuelle Lage der Kundenseite werden nicht wahrgenommen"
      ]
    }
  },
  "fi": {
    "preparingTheGround": {
      "id": "preparingTheGround",
      "index": 0,
      "title": "Maaperän valmistelu",
      "summary": "Ymmärtää tuote-/palveluportfolion; tunnistaa trendit ja markkinat; määrittelee ja seuraa tavoitteita.",
      "high": [
        "Kiinnostunut tuotteista, trendeistä ja markkinoiden kehityksestä sekä tunnistaa (uusia) mahdollisuuksia",
        "Suurempi kyky tunnistaa kokonaiskuva sekä siihen liittyvät kaupalliset mahdollisuudet ja trendit",
        "Halu viedä asioita eteenpäin energisesti ja nopeassa tahdissa"
      ],
      "low": [
        "Merkittävät kaupalliset trendit ja mahdollisuudet havaitaan liian myöhään, jolloin ei ole tarpeeksi aikaa valmistautua tai tarttua niihin",
        "Organisaatio ei pysty tuottamaan uusia ratkaisuja/konsepteja markkinoille"
      ]
    },
    "identifyingOpportunities": {
      "id": "identifyingOpportunities",
      "index": 1,
      "title": "Mahdollisuuksien tunnistaminen",
      "summary": "Tunnistaa mahdolliset asiakasryhmät; kerää tietoja potentiaalisista asiakkaista; suunnittelee sopivan lähestymistavan.",
      "high": [
        "Suurempi kyky tunnistaa mahdolliset asiakkaat, jotka on mahdollista voittaa, sekä tavat lähestyä heitä",
        "Systemaattisia lähestymistavassaan, kilpailuhenkisiä ja haluavat haastaa itseään ammatillisesti"
      ],
      "low": [
        "Tiimi keskittää ponnistelunsa liikaa asiakkaisiin, joiden kohdalla sillä ei ole kilpailuetua tai keinoa erottautua muista markkinoilla toimijoista",
        "Organisaatiolta puuttuu kyky tunnistaa uusia asiakkaita"
      ]
    },
    "contactingPotentialCustomers": {
      "id": "contactingPotentialCustomers",
      "index": 2,
      "title": "Yhteydenotot mahdollisiin asiakkaisiin",
      "summary": "Hankkii liidejä, soittaa ja ottaa yhteyttä asiakkaisiin; kirjoittaa vakuuttavia sähköposteja ja viestejä; sopii tapaamisia.",
      "high": [
        "Itsevarma ja sosiaalinen myynnin ammattilainen, joka täyttää kalenterinsa tarmokkaalla ja tunnollisella työotteella.",
        "Pystyy tuottamaan liidejä myyntitiimille monien eri kanavien kautta omien vahvuuksiensa mukaan (kasvokkain, puhelimitse tai digitaalisesti).",
        "Parhaita liidien tuottajia motivoi yleensä vahva intohimo tuotteeseen tai palveluun, jonka puolesta he puhuvat kaikkia kunnioittaen."
      ],
      "low": [
        "Asiakas- ja liiditapaamisia kiinnostuneiden osapuolten kanssa ei synny riittävästi.",
        "Organisaatio ja sen viesti eivät välttämättä saa riittävästi huomiota markkinoilla, joilla se toimii."
      ]
    },
    "establishingRelationships": {
      "id": "establishingRelationships",
      "index": 3,
      "title": "Suhteiden luominen",
      "summary": "Luo tapaamisissa luottamuksellisen yhteyden; pyrkii ymmärtämään asiakkaan tarpeita; jättää myönteisen vaikutelman.",
      "high": [
        "Tekee loistavan ensivaikutelman ja luo luottamuksellisen suhteen",
        "Luontainen verkostoituja, joka ymmärtää erinomaisesti erilaisia käyttäytymistyyppejä ja osaa hyödyntää tätä tarkoituksenmukaisesti",
        "Keskittyvät yleensä muihin ihmisiin ja omaan tiimiinsä, jossa he arvostavat reilua ja hauskaa ilmapiiriä"
      ],
      "low": [
        "Uusien hyödyllisten kontaktien verkostoa ei kehitetä aktiivisesti, ja se jää vajaakäytölle",
        "Asiakassuhde ei etene pelkkää kaupankäyntiä pidemmälle, joten luottamusta on vähän, mikä vaikeuttaa haasteiden, ongelmien ja tavoitteiden esille tuomista"
      ]
    },
    "preparingASolution": {
      "id": "preparingASolution",
      "index": 4,
      "title": "Ratkaisun valmistelu",
      "summary": "Tunnistaa asiakkaan tarpeisiin ja ongelmiin sopivat tuotteet/palvelut/ratkaisut; laatii ehdotuksen; varmistaa resurssien saatavuuden.",
      "high": [
        "Tunnistaa ja ratkaisee erinomaisesti asiakkaan monimutkaisetkin haasteet",
        "Ovat yleensä avoimia uusille kokemuksille, ja heillä on vilkas mielikuvitus",
        "Taitava laatimaan asiakkaalle tai konseptille räätälöity ratkaisu",
        "Riittäviä resursseja ja yhteistyötä arvostetaan"
      ],
      "low": [
        "Tarjotut ratkaisut eivät ole sopivia asiakkaalle eivätkä erotu positiivisesti markkinoilla",
        "Ratkaisujen laatu on puutteellinen, tai niissä ei huomioida pitkän aikavälin vaikutuksia"
      ]
    },
    "makingTheDeal": {
      "id": "makingTheDeal",
      "index": 5,
      "title": "Sopimuksen tekeminen",
      "summary": "Pitää esityksiä; keskustelee vaihtoehdoista; edistää suunnitelmia ja ideoita; neuvottelee menestyksekkäästi ja saa aikaan sopimuksia.",
      "high": [
        "Osaa viedä kaupat maaliin",
        "Itsevarma, kilpailuhenkinen ja tulosorientoitunut",
        "Luontainen esiintyjä, joka osaa keskustella eri vaihtoehdoista",
        "Taloudelliset kannustimet sekä mahdollisuudet ottaa vastuuta ja vaikuttaa ovat yleisiä motivaation lähteitä"
      ],
      "low": [
        "Asiakkaat eivät ole vakuuttuneita ehdotetuista järjestelyistä, mikä vaikeuttaa kaupan päättämistä",
        "Neuvotellussa sopimuksessa osa osapuolista vetää pitkällä aikavälillä lyhyemmän korren"
      ]
    },
    "deliveringToPromise": {
      "id": "deliveringToPromise",
      "index": 6,
      "title": "Lupauksen täyttäminen",
      "summary": "Valmistelee toimituksen; tiedottaa muille ja ottaa heidät mukaan; seuraa toimitusta, jotta tavoitteet ja odotukset täyttyvät.",
      "high": [
        "Varmistaa, että asiakas saa tuotteen/palvelun sovitun ja luvatun mukaisesti",
        "Käyttävät mielellään energiaansa tuotteen/palvelun valmisteluun, toimittamiseen, seurantaan ja luovutukseen ja pitävät samalla asiakkaan ja tiimin ajan tasalla",
        "Positiivisesti vastaanotetusta toimituksesta saatu palaute sekä selkeät vastuut ja rakenteet motivoivat näitä henkilöitä"
      ],
      "low": [
        "Lupauksia asiakkaille ei pidetä",
        "Aikatauluissa, budjeteissa ja logistiikassa on usein ongelmia"
      ]
    },
    "ensureCustomerSatisfaction": {
      "id": "ensureCustomerSatisfaction",
      "index": 7,
      "title": "Asiakastyytyväisyyden varmistaminen",
      "summary": "Pitää yhteyttä asiakkaisiin; seuraa tyytyväisyyttä; auttaa ratkaisemaan mahdollisia ongelmia.",
      "high": [
        "Sosiaaliset tiimipelaajat, jotka ottavat muut hyvin huomioon",
        "Nauttivat työskentelystä nykyisten asiakkaiden kanssa ja varmistavat, että heidän tarpeensa täyttyvät ja he ovat tyytyväisiä. Eivät pelkää tarttua toimeen asiakkaiden kanssa ja korjata mahdollisia ongelmia ja haasteita",
        "Positiivinen ja avoin työympäristö on yleensä näille henkilöille tärkeä arvo ja motivaation lähde"
      ],
      "low": [
        "Asiakasvaihtuvuus on suurta. Jopa hyviä ja erittäin kannattavia asiakkaita menetetään helpommin kuin pitäisi",
        "Asiakkaiden tarpeita ja nykytilannetta ei tunneta"
      ]
    }
  }
};

export default dictionary;
